module.exports = __webpack_public_path__ + "stylesheets/fonts-basic_c8af4402ea50d0f0b62ceb5f5987b17f.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/fonts/fonts-basic.less
// module id = tWLz
// module chunks = 154 155